// Your data, as Account.dc.html draws it: 2 requests, each a hub.data_requests row that raises a
// data_request flag for Adam, with the board's line after it. An export is built and a deletion
// confirmed by Adam at stage 5; asking twice gives the same line, since only 1 of each kind can be
// open at once.
//
// Once Adam has made the export (data-export, stage 5), its email sends them here: the copy shows with
// a download button for 7 days, through a link sign-file signs for 2 minutes (only their own export,
// and never while staff view as them). No board draws it; the words are in the stage 5 batch.
import { useEffect, useState } from 'react'
import { shortDate } from '../lib/format.js'
import { COPY, lineFor } from './copy.js'
import { askForData, loadDataExport, callMember, EXPORT_DAYS } from './load.js'

export default function YourData({ personId, readOnly }) {
  const [busy, setBusy] = useState(false)
  const [msg, setMsg] = useState({ text: '', error: false })
  const [ready, setReady] = useState(null)
  const [dl, setDl] = useState({ busy: false, error: '' })

  useEffect(() => {
    let live = true
    loadDataExport(personId).then(row => { if (live) setReady(row) }, () => {})
    return () => { live = false }
  }, [personId])

  async function download() {
    if (dl.busy || readOnly || !ready) return
    setDl({ busy: true, error: '' })
    try {
      const d = await callMember('sign-file', { data_export: ready.id })
      setDl({ busy: false, error: '' })
      window.location.assign(d.url)
    } catch (err) {
      setDl({ busy: false, error: err?.message ? lineFor(err) : COPY.downloadFailed })
    }
  }

  async function ask(kind) {
    if (busy || readOnly) return
    setBusy(true)
    setMsg({ text: '', error: false })
    try {
      await askForData(personId, kind)
      setMsg({ text: kind === 'export' ? COPY.exportAsked : COPY.deleteAsked, error: false })
    } catch {
      setMsg({ text: COPY.dataFailed, error: true })
    } finally {
      setBusy(false)
    }
  }

  return (
    <section id="data" className="ac-card ac-card--data" aria-labelledby="data-h">
      <h2 id="data-h" className="ac-h2">{COPY.yourData}</h2>
      {ready && (
        <div className="ac-export">
          <p className="ac-lede">{COPY.exportReady(shortDate(Date.parse(ready.handled_at) + EXPORT_DAYS * 86400000))}</p>
          <div className="ac-row">
            <button type="button" className="ac-btn ac-btn--ink" onClick={download} disabled={readOnly || dl.busy} aria-busy={dl.busy || undefined}>{COPY.downloadExport}</button>
          </div>
          {dl.error && <p className="ac-msg ac-msg--error" role="alert">{dl.error}</p>}
        </div>
      )}
      <div className="ac-row ac-row--data">
        <button type="button" className="ac-btn" onClick={() => ask('export')} disabled={readOnly || busy}>{COPY.askExport}</button>
        <button type="button" className="ac-btn" onClick={() => ask('delete')} disabled={readOnly || busy}>{COPY.askDelete}</button>
      </div>
      {msg.error
        ? <p className="ac-msg ac-msg--error ac-data-msg" role="alert">{msg.text}</p>
        : <p className="ac-msg ac-data-msg" role="status">{msg.text}</p>}
    </section>
  )
}
